<div class="div-buttons mt-2">
  <div class="me-3">
    <button (click)="delete()" type="button" class="btn btn-danger btn-sm" title="Удалить">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
  <div *ngIf="isActivate" class="me-2">
    <button (click)="changeActivate()" type="button" class="btn btn-light btn-sm">Деактивировать</button>
  </div>
  <div *ngIf="!isActivate" class="me-2">
    <button (click)="changeActivate()" type="button" class="btn btn-light btn-sm">Активировать</button>
  </div>
</div>
<div *ngIf="errorDeleteStatus"
     class="text-danger extraErrorsStyles">
  {{ errorDeleteStatus }}
</div>
<div *ngIf="errorChangeActivateStatus"
     class="text-danger extraErrorsStyles">
  {{ errorChangeActivateStatus }}
</div>

